import styled from 'styled-components';

export const SanityRichTextContainer = styled.div<{ fontSize?: string }>`
	box-sizing: border-box;
	font-size: ${({ fontSize }) => fontSize || '1.125rem'};
	color: ${({ theme }) => theme.v3.colors.dark[0]};
	line-height: 1.3;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-bottom: 1rem;
		color: ${({ theme }) => theme.v3.colors.dark[8]};
		scroll-margin-top: 2.5rem;
	}

	p {
		line-height: 1.8;

		&:not(:first-child) {
			margin: 1rem 0;
		}
	}

	p p,
	ul,
	ol {
		+ h1,
		+ h2,
		+ h3,
		+ h4,
		+ h5,
		+ h6 {
			margin-top: 2.5rem;
		}
	}

	ul,
	ol {
		margin: 0 0 1rem;
		padding-left: 1.5rem;
		line-height: 1.8;
		list-style-type: disc;

		li::marker {
			font-size: inherit;
		}
	}

	ol {
		margin-bottom: 0;
		list-style-type: decimal;

		ul,
		ol {
			list-style-type: disc;
		}
	}

	img {
		margin: 2.5rem 0;
	}

	blockquote,
	.quote {
		margin: 2.5rem 0;
		border-left: 2px solid ${({ theme }) => theme.v3.colors.gray[4]};
		padding: 0.5rem 0 0.5rem 1rem;

		&-text {
			color: ${({ theme }) => theme.v3.colors.dark[8]};
			line-height: 1.6;
		}

		cite {
			display: block;
			margin-top: 2rem;
		}
	}

	.link {
		text-decoration: underline;
		color: ${({ theme }) => theme.v3.colors.blue[6]};
	}

	.video,
	.guideflow {
		margin: 2.5rem 0;
	}
`;
